export default "__VITE_ASSET__20d174ac__"